'use strict';

/*
    base controller for all step controllers
    see spec for usage example
*/
export var baseStepController = function(workflowService, loggingService, $state, $q, $window, $location) {
    var vm = this;

    vm.executionStep = null;
    vm.ticketId = null;
    vm.stepId = null;

    vm.initializeStep = function(stateParams) {
        var deferred = $q.defer(); 
        var executionStep = stateParams.executionStep;
        vm.ticketId = stateParams.ticketId;
        vm.stepId = stateParams.stepId;
        
        if (executionStep) {
            vm.executionStep = executionStep;
            deferred.resolve(executionStep);
        } else {
            workflowService.initializeStep(vm.ticketId, vm.stepId)
                .then(function(execStep) {
                    vm.executionStep = execStep;
                    deferred.resolve(execStep);
                }).catch(function(data) {
                    vm.error(data.data.error);
                });
        }

        return deferred.promise;
    }

    vm.setExecutionStep = function(executionStep) {
        vm.executionStep = executionStep;
    }

    vm.transition = function(ticketId, ticketStep) {
        vm.ticketId = ticketId;
        if (vm.executionStep !== null) ticketStep = vm.executionStep.ticketStep;
        workflowService.transition(
                ticketId || ticketStep.ticketId,
                ticketStep)
            .catch(function(data) {
                vm.error(data.data.error);
            });
    }

    vm.error = function(error, transition) {
        if (!transition) transition = true
        var properties = {};
        if (vm.executionStep && vm.executionStep.ticketStep) {
            var ticketStep = vm.executionStep.ticketStep;
            properties.ticketStepId = ticketStep.id;
            properties.studyId = ticketStep.studyId;
            properties.ticketId = ticketStep.ticketId;
            properties.stepId = ticketStep.stepId;
        } else {
            properties.ticketId = vm.ticketId;
            properties.stepId = vm.stepId;
        }

        loggingService.error(error, properties);
        loggingService.flush();

        if (transition)
            $state.go('error');
    }

    vm.messageParent = function(messageType, messageData) {
        var parentWindow = $window.parent;
        var message = {
            messageType: messageType,
            messageData: messageData
        };

        parentWindow.postMessage(message, '*');
    }
};

baseStepController.$inject = [ 'workflowService', 'loggingService', '$state', '$q', '$window', '$location'];